import { render, staticRenderFns } from "./AssignmentOfferDetail.vue?vue&type=template&id=2356a112&scoped=true&"
import script from "./assignmentOfferDetail?vue&type=script&lang=js&"
export * from "./assignmentOfferDetail?vue&type=script&lang=js&"
import style0 from "./AssignmentOfferDetail.vue?vue&type=style&index=0&id=2356a112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2356a112",
  null
  
)

export default component.exports